// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__w1V49","content":"styles_content__1lprC","selectAll":"styles_selectAll__2PokF"};